import React, { useState } from "react";
import { TextField, Card, Text, Button, Avatar } from "@radix-ui/themes";
import eyeIcon from "../../assets/eye.png";
import "./Login.css";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { login } from "../../Services/Auth";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const { setloader, initAlert } = GeneralContextFunc();
  const [showPass, setShowPass] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const loginBtn = () => {
    if (Object.values(formData).some((elem) => elem === "")) {
      initAlert("Please enter values", "warning");
      return;
    }
    setloader(true);
    let payload = {
      email: formData.email,
      password: formData.password,
    };

    login(payload)
      .then((res) => {
        // Check if user has SUPERADMIN role
        if (res.info.role !== "SUPERADMIN") {
          setloader(false);
          initAlert("Access Denied: You are not authorized to access this application. Please contact your administrator for proper credentials.", "error");
          return;
        }
        console.log("Login Response:", res);
        
        localStorage.setItem("userId", res.info.userId);
        localStorage.setItem("token", res.info.accessToken);
        localStorage.setItem("userRole", res.info.role);
        localStorage.setItem("userName", `${res.info.firstName} ${res.info.lastName}`);
        setloader(false);
        initAlert(res?.message);
        navigate("/home");
      })
      .catch((err) => {
        setloader(false);
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };
  return (
    <div className="login-page">
      <Card className="login-card">
        <Text as="div" size="5" weight="bold">
          Login
        </Text>
        <TextField.Root
          size="3"
          radius="full"
          mt="3"
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          placeholder="Email"
          value={formData.email}
        ></TextField.Root>
        <TextField.Root
          size="3"
          radius="full"
          mt="3"
          onChange={(e) =>
            setFormData({ ...formData, password: e.target.value })
          }
          placeholder="Password"
          value={formData.password}
          type={showPass ? "text" : "password"}
        >
          <TextField.Slot
            style={{ cursor: "pointer" }}
            onClick={() => setShowPass(!showPass)}
            side="right"
          >
            <Avatar
              size="1"
              style={{ padding: "2px" }}
              src={eyeIcon}
              fallback="i"
            />
          </TextField.Slot>
        </TextField.Root>
        <Button
          mt="3"
          style={{ width: "100%" }}
          size="3"
          onClick={() => loginBtn()}
          radius="full"
        >
          Login
        </Button>
      </Card>
    </div>
  );
};

export default Login;
